import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Tooltip,
  IconButton,
  Avatar,
  CardMedia,
} from "@mui/material";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { DataGrid, faIR } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import CustomPagination from "../../../components/CustomPagination";
import DeleteIcon from "@mui/icons-material/Delete";
import { UseHeader } from "./UseHeader";
import YesOrNoDialoge from "../../../components/YesOrNoDialoge";
import { rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { readFromLS } from "../../../util/LocalStrogeService";

export default function TopBanner(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [topBanners, setTopBanners] = useState([]);
  const [progress, setProgress] = useRecoilState(rsProgress);

  const { GetHeader, RemoveHeaderTopBanner } = UseHeader();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });
  const newFunc = () => {
    return navigate("/headerManage/addTopBanner");
  };
  const [homePageId, setHomePageid] = useState(
    readFromLS("homePage") ? readFromLS("homePage") : ""
  );
  useEffect(() => {
    setProgress(true);
    GetHeader(
      homePageId?.id ? homePageId.id : 1,
      (header) => {
        setTopBanners(header.topBanner);
      },
      false
    );
  }, []);

  const columns = [
    {
      field: "id",
      width: 70,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
    },
    {
      field: "image2",
      width: 400,
      align: "center",
      headerName: "تصویر",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <CardMedia
            component="img"
            sx={{ width: "auto" }}
            image={cellValues.row.image2}
          />
        );
      },
    },
    {
      field: "active",
      headerName: "فعال",
      width: 80,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.active ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 110,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="حذف">
              <IconButton
                sx={{ p: 0.5, mr: 0.5 }}
                onClick={() => {
                  setCheckState({
                    show: true,
                    name: "حذف این بنر ",
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  return navigate("/headerManage/editTopBanner", {
                    state: {
                      model: cellValues.row,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "60%",
      }}
    >
      <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
        هدرهای صفحه نخست
      </Typography>
      <DataGrid
        className="ltr-grid"
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={topBanners ? topBanners : []}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={topBanners && topBanners.length ? topBanners.length : 1}
        enableRangeSelection={true}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            newFunc: newFunc,
            isLtr: true,
            rowCount: topBanners && topBanners.length ? topBanners.length : "",
          },
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "id",
                sort: "asc",
              },
            ],
          },
        }}
      />
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          RemoveHeaderTopBanner(checkState.id, () => {
            GetHeader(
              homePageId?.id ? homePageId.id : 1,
              (header) => {
                setTopBanners(header.topBanner);
              },
              false
            );
          });
        }}
      />
    </Box>
  );
}
